<template>
  <div
    class="relative z-30 flex flex-col items-center justify-stretch gap-6 rounded-lg bg-white p-6 drop-shadow-md"
  >
    <div class="flex w-full flex-row items-center justify-start">
      <Button
        class="hover-lift-no-shadow text-left"
        variant="ghost-no-padding"
        transition="transition-all"
        @click="redirectToPage('redesign.company.pipelines.index')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <mask
            id="mask0_5651_5525"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="20"
          >
            <rect width="20" height="20" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_5651_5525)">
            <path
              d="M7.74196 10.0001L14.0192 16.2773C14.1848 16.4429 14.2655 16.6379 14.2612 16.8622C14.2569 17.0866 14.172 17.2816 14.0064 17.4472C13.8408 17.6128 13.6458 17.6956 13.4215 17.6956C13.1971 17.6956 13.0021 17.6128 12.8365 17.4472L6.44392 11.0673C6.29325 10.9167 6.1816 10.7479 6.10896 10.5609C6.03632 10.374 6 10.187 6 10.0001C6 9.81309 6.03632 9.62613 6.10896 9.43916C6.18161 9.2522 6.29326 9.0834 6.44392 8.93276L12.8365 2.54013C13.0021 2.37454 13.1992 2.29387 13.4279 2.29813C13.6565 2.30241 13.8536 2.38735 14.0192 2.55295C14.1848 2.71854 14.2676 2.91352 14.2676 3.13786C14.2676 3.36222 14.1848 3.5572 14.0192 3.7228L7.74196 10.0001Z"
              fill="#27272A"
            />
          </g>
        </svg>

        <span class="ml-1.5 text-sm text-zinc-600">
          {{ __('Pipelines') }}
        </span>
      </Button>
    </div>
    <div class="flex w-full flex-col items-center justify-between sm:flex-row">
      <div
        class="mr-0 flex w-full items-center justify-between gap-4 text-left text-3xl font-bold sm:mr-8 md:justify-start"
      >
        <div class="flex flex-row gap-2">
          <PipelineActionsMobilePopup
            v-if="isMobile"
            :isOwner="data.pipeline.isOwner"
            @edit="
              redirectToPage(
                'redesign.company.pipelines.edit',
                data.pipeline.id
              )
            "
            @delete="isDeletePipelineModalOpen = true"
          >
          </PipelineActionsMobilePopup>

          <div class="min-w-0 max-w-[25rem] flex-1 sm:max-w-[35rem]">
            <div
              class="line-clamp-3 break-words text-xl font-medium sm:text-3xl"
            >
              {{ data.pipeline.name }}
            </div>
          </div>
        </div>
        <InputToggle
          :id="`${data.pipeline.id}`"
          :value="Boolean(data.pipeline.status)"
          @update:value="handlePipelineEditStatus()"
        />
      </div>
      <div class="w-full sm:hidden">
        <div class="mb-2 mt-6 flex h-10 w-full items-center justify-between">
          <button
            @click="setActiveTab(1)"
            class="mx-auto h-full w-full cursor-pointer rounded-l-md border transition-colors duration-200"
            :class="
              activeTab === 1
                ? 'border-secondary bg-secondary text-white'
                : 'border-zinc-300 bg-white text-black'
            "
          >
            <span class="text-sm">{{ __('Info') }} </span>
          </button>
          <button
            @click="setActiveTab(2)"
            class="mx-auto h-full w-full cursor-pointer rounded-r-md border transition-colors duration-200"
            :class="
              activeTab === 2
                ? 'border-secondary bg-secondary text-white'
                : 'border-zinc-300 bg-white text-black'
            "
          >
            <span class="text-sm"> {{ __('Candidates') }}</span>
          </button>
        </div>
      </div>

      <div
        v-if="!isMobile"
        class="mt-4 flex flex-row justify-start gap-4 sm:mt-0 sm:justify-center"
      >
        <Button
          class="hover-lift flex w-fit items-center justify-between gap-1.5 p-1 text-center"
          transition="transition-all"
          variant="outline-no-hover"
          @click="
            redirectToPage('redesign.company.pipelines.edit', data.pipeline.id)
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            class="fill-primary"
          >
            <rect width="18" height="18" fill="white" />
            <mask
              id="mask0_5582_302"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="18"
              height="18"
            >
              <rect width="18" height="18" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_5582_302)">
              <path
                d="M13.5944 6.39863L10.5713 3.40685L11.5672 2.40959C11.8398 2.13653 12.1748 2 12.5719 2C12.9691 2 13.304 2.13653 13.5766 2.40959L14.5725 3.40685C14.8451 3.67991 14.9874 4.00936 14.9993 4.39521C15.0111 4.78105 14.8807 5.1105 14.608 5.38356L13.5944 6.39863ZM2.71131 15C2.50977 15 2.34084 14.9317 2.2045 14.7952C2.06817 14.6587 2 14.4895 2 14.2877V12.2753C2 12.1804 2.01778 12.0884 2.05335 11.9993C2.08891 11.9103 2.14226 11.8301 2.21339 11.7589L9.53993 4.42192L12.563 7.44932L5.23648 14.7863C5.16535 14.8575 5.08532 14.911 4.99641 14.9466C4.9075 14.9822 4.81562 15 4.72078 15H2.71131Z"
              />
            </g>
          </svg>
          <span class="text-primary">
            {{ __('Edit') }}
          </span>
        </Button>

        <Button
          v-if="data.pipeline.is_owner"
          class="hover-lift flex w-fit items-center gap-1.5"
          transition="transition-all"
          @click="isDeletePipelineModalOpen = true"
        >
          <span class="text-center">
            {{ __('Delete') }}
          </span>
        </Button>
      </div>
    </div>

    <div
      v-if="!isMobile || activeTab === 1"
      class="grid grid-cols-1 items-start gap-x-10 gap-y-4 self-stretch rounded-2xl border border-zinc-300 p-6 sm:grid-cols-2"
    >
      <div class="flex flex-row items-center justify-between">
        <span class="text-zinc-600"> {{ __('Job Title') }}</span>
        <span class="text-right font-medium">
          {{ data.pipeline.std_title.name }}</span
        >
      </div>

      <div class="flex flex-row items-center justify-between">
        <span class="text-zinc-600"> {{ __('Start/End Date') }}</span>
        <span class="text-right font-medium">
          {{ formatDate(data.pipeline.start_date) ?? 'N/A' }} -
          {{ formatDate(data.pipeline.end_date) ?? 'N/A' }}</span
        >
      </div>

      <div class="flex flex-row items-center justify-between">
        <span class="text-zinc-600"> {{ __('Pipeline Status') }}</span>
        <div
          class="flex items-center justify-center rounded-lg bg-primary/10 px-3.5 py-0.5"
        >
          <span class="text-base font-medium text-primary">
            {{ data.pipeline.project_status.name }}
          </span>
        </div>
      </div>

      <div class="flex flex-row items-center justify-between">
        <span class="text-zinc-600"> {{ __('Pipeline Description') }}</span>
        <Button
          variant="ghost-no-padding"
          transition="transition-all"
          class="hover-lift-no-shadow"
          @click="
            redirectToPage('redesign.company.pipelines.edit', data.pipeline.id)
          "
        >
          <span class="text-right underline">
            {{ __('View Description') }}
          </span>
        </Button>
      </div>

      <div class="flex flex-row items-center justify-between">
        <span class="text-zinc-600"> {{ __('Open Positions') }}</span>
        <span class="text-right font-medium">
          {{
            data.pipeline.open_positions != null
              ? data.pipeline.open_positions + __(' roles planned')
              : 'N/A'
          }}
        </span>
      </div>

      <div class="flex flex-row items-center justify-between">
        <span class="text-zinc-600"> {{ __('Last Updated') }}</span>
        <span class="text-right font-medium">
          {{
            data.pipeline.updated_by && data.pipeline.updated_at
              ? `${__('By')} ${data.pipeline.updated_by} ${__('on')} ${formatDate(data.pipeline.updated_at)}`
              : 'N/A'
          }}
        </span>
      </div>

      <div class="flex flex-row items-center justify-between">
        <span class="text-zinc-600"> {{ __('Wage') }}</span>
        <span class="text-right font-medium">
          {{ data.pipeline.salary.wage ?? 'N/A' }}</span
        >
      </div>

      <div class="flex flex-row items-center justify-between">
        <span class="mr-5 text-left text-zinc-600 sm:mr-0">
          {{ __('Collaborators') }}</span
        >
        <div
          v-if="data.pipeline.collaborators.length > 1"
          class="flex flex-row items-center gap-4"
        >
          <div
            :class="
              data.pipeline.collaborators.length > 1
                ? 'flex -space-x-1'
                : 'flex flex-shrink-0'
            "
          >
            <img
              v-for="collaborators in data.pipeline.collaborators"
              class="block size-6 rounded-full ring-2 ring-white"
              :src="collaborators.profile_picture_url"
              alt=""
            />
          </div>
          <PipelineCollaboratorsPopup :data="data.pipeline.collaborators">
          </PipelineCollaboratorsPopup>
        </div>
        <Button
          v-else
          variant="ghost-no-padding"
          transition="transition-all"
          class="hover-lift-no-shadow"
          @click="
            redirectToPage('redesign.company.pipelines.edit', data.pipeline.id)
          "
        >
          <span class="text-right underline">
            {{ __('Add Collaborators') }}
          </span>
        </Button>
      </div>
    </div>
  </div>

  <PipelinesDeleteModal
    v-if="isDeletePipelineModalOpen"
    :pipelineId="data.pipeline.id"
    @delete="handlePipelineDelete"
    @cancel="isDeletePipelineModalOpen = false"
  ></PipelinesDeleteModal>
</template>

<script setup>
  import InputToggle from '@/components/form/input-toggle/input-toggle.vue';
  import { ref } from 'vue';
  import axios from 'axios';
  import { useToast } from 'vue-toastification';
  import { Button } from '../../../../../components/block/button';
  import PipelinesDeleteModal from '../PipelinesDeleteModal.vue';
  import PipelineActionsMobilePopup from './components/PipelineActionsMobilePopup.vue';
  import PipelineCollaboratorsPopup from './components/PipelineCollaboratorsPopup.vue';

  import { __ } from '@/helpers';
  const props = defineProps({
    data: Object,
    isMobile: {
      type: Boolean,
      default: false
    }
  });

  const emit = defineEmits(['tab-changed']);

  const activeTab = ref(1);

  const setActiveTab = (tab) => {
    activeTab.value = tab;
    emit('tab-changed', tab);
  };
  const toast = useToast();
  const data = ref(props.data);
  const isDeletePipelineModalOpen = ref(false);

  const formatDate = (date) => {
    if (!date) return null;
    return date.split('-').join('.'); // 2024-12-25 → 2024.12.25
  };

  const handlePipelineEditStatus = async () => {
    try {
      const response = await axios.patch(
        route(
          'redesign.company.pipelines.toggle-status',
          data.value.pipeline.id
        ),
        {
          status: !data.value.pipeline.status,
          updated_at: data.value.pipeline.updated_at_full
        }
      );

      toast.success(
        response?.data?.message || __('Pipeline status modified successfully')
      );
      data.value.pipeline.status = response.data.status;
      data.value.pipeline.updated_at_full = response.data.updated_at;
    } catch (error) {
      toast.error(
        error.response?.data?.message || __('Error modifying pipeline status')
      );
    }
  };

  const redirectToPage = (name, params) => {
    window.location.href = route(name, params);
  };

  const handlePipelineDelete = async (pipelineId) => {
    try {
      const response = await axios.delete(
        route('redesign.company.pipelines.destroy', {
          pipelineId: pipelineId
        })
      );

      sessionStorage.setItem(
        'toast_message',
        JSON.stringify({
          type: 'success',
          message: response?.data?.message
        })
      );
      redirectToPage('redesign.company.pipelines.index');
    } catch (error) {
      toast.error(
        error.response?.data?.message || __('Error deleting pipeline')
      );
    }
  };
</script>
